import { render, staticRenderFns } from "./CreateWebsite.vue?vue&type=template&id=6f1b5882&"
import script from "./CreateWebsite.vue?vue&type=script&lang=ts&"
export * from "./CreateWebsite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports